export default __webpack_public_path__ + "static/media/txt4.7af6247a.jpg";